import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from '../../util_grid/grid.js';
import './styles/styles.scss';

class BannerCampaign extends Component {
  get title() {
    return this.props.title || null;
  }

  get alt() {
    return this.props.alt || '';
  }

  get firstLogo() {
    return this.props.firstLogo || '';
  }

  get secondLogo() {
    return this.props.secondLogo || '';
  }

  get classes() {
    return this.props.classes || '';
  }

  get images() {
    return {
      image: this.props.image || null,
      imageTablet: this.props.imageTablet || null,
      imageMobile: this.props.imageMobile || null,
    };
  }

  render() {
    return (
      <div className="banner-responsive banner-campaign">
        {this.images.image &&
          <picture>
            <source media="(max-width: 480px)" srcSet={this.images.imageMobile}/>
            <source media="(max-width: 1024px)" srcSet={this.images.imageTablet}/>
            <img srcSet={this.images.image} alt={this.alt}/>
          </picture>
        }
        <div className="banner-responsive-media">
          <div className="banner-responsive-body container">
            <Row>
              <Col xs={12} className={this.classes}>
                <div className="banner-reponsive-contentwrapper">
                  {!!(this.firstLogo || this.secondLogo) &&
                    <div className="banner-responsive-logos">
                      {!!this.firstLogo &&
                        <img src={this.firstLogo} alt={this.title}/>
                      }
                      {!!this.secondLogo &&
                        <img src={this.secondLogo} alt={this.title}/>
                      }
                    </div>
                  }
                  {!!this.title &&
                    <h1 className="banner-responsive-title">
                      {this.title}
                    </h1>
                  }
                </div>
              </Col>
            </Row>
          </div>
        </div>
      </div>
    );
  }
}


BannerCampaign.propTypes = {
  /**
   * The title which will be shown in black in the banner
   */
  title: PropTypes.string,
  /**
   * The subtitle which will be shown in green in the banner
   */
  subtitle: PropTypes.string,
  /**
   * Image placed in the background
   */
  image: PropTypes.string,
  /**
   * Image place on the left side of the banner
   */
  imageTablet: PropTypes.string,
  /**
   * Image place on the right side of the banner
   */
  imageMobile: PropTypes.string,
  classes: PropTypes.string,
  alt: PropTypes.string,
  firstLogo: PropTypes.string,
  secondLogo: PropTypes.string,
};


export default BannerCampaign;
